import { createContext } from "react";

interface RoutingContextValue {
  /**
   * All routes should be prefixed with this path prefix
   */
  pathPrefix: string | null;
}

export const RoutingContext = createContext<RoutingContextValue>({
  pathPrefix: null,
});
